<template>
  <div class="layer-item">
    <vs-radio
      class="w-full"
      :color="AISEA_COLOR.BLUE"
      v-model="styleType"
      :vs-value="layer.id"
    >
      <div class="map-styles-container w-full">
        <div class="item1">
          <span class="aisea-text-16-300-white">{{ layer.name }}</span>
        </div>
        <div class="item2">
          <img :src="layer.img" :class="imgClassObject()" />
        </div>
      </div>
    </vs-radio>
  </div>
</template>

<script>
/**
 * 地図の一覧の一つを表示するコンポーネント
 * @parent M.LayerCard
 * @props layer: Object 選択肢に表示するレイヤー情報
 * @props selectedStyleType: Number 選択済のレイヤーID
 * @props updateStyleType: Function 選択済のレイヤーIDを更新するための関数
 */
import { ColorMixin } from "@/mixins";

export default {
  name: "A.LayerItem",
  mixins: [ColorMixin],
  props: {
    /** 選択肢に表示するレイヤー情報 */
    layer: {
      type: Object,
      required: true,
    },
    /** 選択済のレイヤーID */
    selectedStyleType: {
      type: Number,
      required: true,
    },
    /** 選択済のレイヤーIDを更新するための関数 */
    updateStyleType: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      styleType: this.selectedStyleType,
    };
  },
  watch: {
    selectedStyleType(value) {
      this.styleType = value;
    },
    async styleType(value) {
      await this.updateStyleType(value);
    },
  },
  methods: {
    imgClassObject() {
      return {
        "select-style": this.layer.id === this.styleType,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
::v-deep .vs-radio--label {
  width: 100%;
}

.layer-item {
  .map-styles-container {
    display: flex;
    justify-content: space-between;
  }
  .item1 {
    flex: 1;
    align-self: center;
  }
  .item2 {
    flex: 0;
    align-self: center;
    margin-right: auto;
  }
  .map-img {
    width: 200px;
    margin-right: auto;
  }
  img {
    width: 90px;
    height: 67.5px;
    border-radius: 5px;
  }
  .select-style {
    border: 2px solid $aisea-blue;
    box-sizing: border-box;
  }
}
</style>
